let lastScrollTop = 0;
const header = document.querySelector('header');
window.addEventListener('scroll', () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop < 20) {
    // находимся в начале страницы
    header.classList.remove('header-hide');
  } else if (scrollTop > lastScrollTop) {
    // скроллим вниз
    header.classList.add('header-hide');
  } else {
    // скроллим вверх
    header.classList.remove('header-hide');
  }
  lastScrollTop = scrollTop;
});
